import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemText } from '@material-ui/core';

import Container from '../../../../components/Base/Container';
import StylesModelInteractor from '../../../../styles/components/StylesModelInteractor';

const SupplierItem = ({
  onClick, item, selected,
}) => {
  const classes = StylesModelInteractor();
  return (
    <ListItem
      component="div"
      className={classes.container}
      classes={{
        selected: classes.selected,
      }}
      onClick={() => onClick(item.id)}
      selected={selected}
      button
    >
      <ListItemText className={classes.content}>
        <Container>
          {`Supplier #${item.id}`}
        </Container>
        <Container className={classes.name}>{item.name.toUpperCase()}</Container>
      </ListItemText>
    </ListItem>
  );
};

SupplierItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
};

export default SupplierItem;
